import { createContext, useContext } from 'react'

export const InspectionsContext = createContext()

export const InspectionsProvider = InspectionsContext.Provider
export const InspectionsConsumer = InspectionsContext.Consumer

export const useInspectionsContext = () => useContext(InspectionsContext)
